export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="relative bg-primary-500 rounded-3xl overflow-hidden">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-2/5 relative">
              <div className="h-64 md:h-full min-h-[300px] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Smiling%20young%20entrepreneur%20in%20modern%20minimal%20workspace%20with%20laptop%20and%20coffee%2C%20warm%20candlelight%20ambiance%2C%20cozy%20home%20office%20interior%2C%20genuine%20casual%20portrait%2C%20soft%20bokeh%20background%2C%20lifestyle%20editorial%20photography&width=600&height=800&seq=testimonial-v2&orientation=portrait"
                  alt="Verified dropshipper using itaobuy spreadsheet"
                  title="Verified Dropshipper - ItaobuySpreadsheet User"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="md:w-3/5 flex flex-col justify-center px-8 py-10 md:px-12 md:py-14">
              <div className="text-7xl md:text-8xl font-heading text-accent-300 leading-none mb-4">
                &ldquo;
              </div>
              <blockquote className="text-lg md:text-xl text-background-50 leading-relaxed mb-6 font-light">
                The <strong className="font-semibold text-background-50">itaobuy spreadsheet</strong> completely changed how I source products. Instead of spending hours on individual supplier pages, I now scan everything in one place and make faster decisions. My dropshipping business scaled 3x after I switched to this system.
              </blockquote>
              <div className="mb-6">
                <p className="text-sm font-semibold text-background-50 whitespace-nowrap">Marcus Chen</p>
                <p className="text-xs text-background-50/60 whitespace-nowrap">Verified Dropshipper, 3+ Years Experience</p>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-400 text-foreground-950 text-sm font-semibold rounded-full hover:bg-accent-300 transition-colors w-fit whitespace-nowrap cursor-pointer"
              >
                Read Full Story
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="absolute top-8 -left-4 opacity-10">
            <svg width="120" height="200" viewBox="0 0 120 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 190 Q40 140 25 100 Q10 60 40 30 T70 10" stroke="white" strokeWidth="1.5" fill="none" />
              <path d="M50 190 Q80 140 65 100 Q50 60 80 30 T110 10" stroke="white" strokeWidth="1.5" fill="none" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}